import * as React from 'react';
import b_ from 'b_';
import Tabs from './components/Tabs';

import './index.scss';

interface Props {}

type Enhanced = Props;

const b = b_.with('main-page-results');

const Results: React.FC<Enhanced> = () => {
  return (
    <div className={b()} data-testid="main-page-results">
      <Tabs />
    </div>
  );
};

export default Results;
